import { Component, OnInit } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../../_services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';

import 'rxjs/add/operator/mergeMap';
import {ACLFeature} from '../../_models/acl-feature';

const log = Log.create('BatchEditDrivers');

@Component({
  templateUrl: 'edit.component.html',
  styleUrls: ['edit.less']
})

export class BatchEditDriversComponent implements OnInit {

  // family: ModuleFamily = new ModuleFamily('test');
  parentId: number;
  path: string;
  familiyIds: any;
  families: any;

  isVisible?: boolean = false;
  isVisibleNa?: boolean = false;
  isVisibleSa?: boolean = false;
  isVisibleCn?: boolean = false;
  isVisibleRoa?: boolean = false;

  isInMaintenanceMode?: boolean = false;
  isInMaintenanceModeNa?: boolean = false;
  isInMaintenanceModeSa?: boolean = false;
  isInMaintenanceModeCn?: boolean = false;
  isInMaintenanceModeRoa?: boolean = false;

  viewStatus?: any;
  viewStatusNa?: any;
  viewStatusSa?: any;
  viewStatusCn?: any;
  viewStatusRoa?: any;

  iCanMaintenanceMode: boolean = false;
  iCanArchive: boolean = true;
  iCanViewArchive: boolean = true;

  sortOrder?: number = null;

  image?: string = null;

  solutionComment?: string = null;

  possibleCapabilities: any;
  capabilities: Array<any> = [];
  possibleDriverFamilies: any;
  possibleDriverFamilyNames: any;
  family?: any = null;
  familyNa?: any = null;
  familySa?: any = null;
  familyCn?: any = null;
  familyRoa?: any = null;

  isRset1: boolean = false;
  isRset2: boolean = false;
  isRset3: boolean = false;
  isRset4s: boolean = false;
  isRset5s: boolean = false;
  isRsetProgrammable: boolean = false;
  isRsetSimpleset: boolean = false;
  isRsetWireless: boolean = false;
  isRsetDipswitch: boolean = false;

  datasheetUrl?: string = ''; // Database does not allow null for datasheetUrls
  datasheetUrlNa?: string = '';
  datasheetUrlSa?: string = '';
  datasheetUrlCn?: string = '';
  datasheetUrlRoa?: string = '';

  phaseIn?: string = null;
  phaseOut?: string = null;
  phaseInNa?: string = null;
  phaseOutNa?: string = null;
  phaseInSa?: string = null;
  phaseOutSa?: string = null;
  phaseInCn?: string = null;
  phaseOutCn?: string = null;
  phaseInRoa?: string = null;
  phaseOutRoa?: string = null;

  csaUrl: string = null;
  file3dUrl: string = null;
  ulUrl: string = null;
  inertekUrl: string = null;

  height: any = 0;
  width: any = 0;
  length: any = 0;
  heightInch: any = 0;
  lengthInch: any = 0;
  widthInch: any = 0;
  boxQuantity: any = 0;

  possibleDimmingTypes: any;
  dimmingTypes: Array<any> = [];

  possibleMountingTypes: any;
  mountingTypes: Array<any> = [];

  possibleCertifications: any;
  certifications: Array<any> = [];

  possibleFeatures: any;
  features: Array<any> = [];

  possibleInputVoltages: any;
  inputVoltages: Array<any> = [];

  possibleIsolationClasses: any;
  isolationClass: any = null;

  dcDim: boolean = false;

  possibleDriverClassifications: any;
  classification: any = {};

  possibleVoltageTypes: any;
  voltageType: any = {};

  toggleVisibility: boolean = false;
  toggleMaintenanceMode: boolean = false;
  toggleSortOrder: boolean = false;
  toggleImages: boolean = false;
  toggleSolutionComment: boolean = false;

  toggleDriverFamily: boolean = false;
  toggleDriverFamilyNa: boolean = false;
  toggleDriverFamilySa: boolean = false;
  toggleDriverFamilyCn: boolean = false;
  toggleDriverFamilyRoa: boolean = false;

  toggleConfigurability: boolean = false;

  toggleDataSheet: boolean = false;
  toggleDataSheetNa: boolean = false;
  toggleDataSheetSa: boolean = false;
  toggleDataSheetCn: boolean = false;
  toggleDataSheetRoa: boolean = false;

  togglePhaseInOut: boolean = false;
  togglePhaseInOutNa: boolean = false;
  togglePhaseInOutSa: boolean = false;
  togglePhaseInOutCn: boolean = false;
  togglePhaseInOutRoa: boolean = false;

  toggleHousing: boolean = false;
  toggleDimmingTypes: boolean = false;
  toggleMountingTypes: boolean = false;
  toggleCertifications: boolean = false;
  toggleFeatures: boolean = false;
  toggleInputVoltages: boolean = false;
  toggleIsolationClass: boolean = false;
  toggleDcDim: boolean = false;
  toggleClassification: boolean = false;
  toggleVoltageType: boolean = false;
  toggleCapabilitie: boolean = false;
  toggleUrls: boolean = false;
  toggleBoxQuantity: boolean = false;

  toggleViewStatus: boolean = false;
  toggleViewStatusNa: boolean = false;
  toggleViewStatusSa: boolean = false;
  toggleViewStatusCn: boolean = false;
  toggleViewStatusRoa: boolean = false;

  loader: boolean = false;

  possibleSensorApplications: any;
  sensorApplications: Array<any> = [];
  toggleSensorApplications: boolean = false;

  possibleSensorFeatures: any;
  sensorFeatures: Array<any> = [];
  toggleSensorFeatures: boolean = false;

  toggleTags: boolean = false;
  tagFamilies: Array<any> = [];
  activeTagFamily: any = null;
  possibleTags: Array<any> = [];
  tags: Array<any> = [];


  constructor(private admin: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private toast: ToastsManager) {}

  ngOnInit() {
    this.loader = true;
    log.d('ngOnInit');
    // this.path = (this.route.snapshot.parent.params['type'] === 'modules') ? '/drilldown/modules' : '/drilldown/drivers';
    //
    this.route.params.subscribe((params: any) => {
      log.d(`route /${this.route.snapshot.parent.params['type']}/${params['id']}`, );
      this.parentId = +params['parentId'];
      this.familiyIds = params.list.split(',').map( param => parseInt(param) ); // moet een array met getallen worden.
      log.d('families recieved from params', this.familiyIds);


      this.admin.getDriverControllers(this.familiyIds).subscribe((data) => {
        log.d('getDriverControllers response', data);
        this.families = data.data;


        this.admin.getDriverFamilies().subscribe((response) => {
          this.possibleDriverFamilyNames = response.data.map(family => {
            return {
              id: family.id,
              text: family.treeName
            };
          });

          this.possibleDriverFamilies = response.data;
          this.loader = false;
        });

        this.admin.getDimmingTypes().subscribe((response) => {
          this.possibleDimmingTypes = response.data;
        });

        this.admin.getMountingTypes().subscribe((response) => {
          this.possibleMountingTypes = response.data;
        });

        this.admin.getCertifications().subscribe((response) => {
          this.possibleCertifications = response.data;
        });

        this.admin.getFeatures().subscribe((response) => {
          this.possibleFeatures = response.data;
        });

        this.admin.getInputVoltages().subscribe((response) => {
          this.possibleInputVoltages = response.data;
        });

        this.admin.getDriverCapabilities().subscribe((res) => {
            this.possibleCapabilities = res.data;
        });

        this.admin.getIsolationClasses().subscribe((response) => {
          this.possibleIsolationClasses = response.data;
        });

        this.admin.getDriverClassifications().subscribe((response) => {
          this.possibleDriverClassifications = response.data;
          this.possibleDriverClassifications.push({
            name: 'None',
            id: null
          });
        });
        this.admin.getVoltageTypes().subscribe((response) => {
          this.possibleVoltageTypes = response.data;
          this.possibleVoltageTypes.push({
            name: 'None',
            id: null
          });
        });

        this.admin.getSensorApplications().subscribe((res) => {
          this.possibleSensorApplications = res.data;
        });

        this.admin.getSensorFeatures().subscribe((res) => {
          this.possibleSensorFeatures = res.data;
        });

        this.admin.getTagFamiliesController().subscribe((res) => {
          this.tagFamilies = res.map((item) => {
            return {id: item.id, text: item.name};
          });
          if (this.tagFamilies.length > 0) {
            this.selectedDriverTagFamily(this.tagFamilies[0]);
          }
        });
      });
    });
    this.admin.canI(ACLFeature.MAINTENANCE_MODE_ADMIN).subscribe((iCan: boolean) => {
      this.iCanMaintenanceMode = iCan;
    });

    this.admin.canI(ACLFeature.VIEW_ARCHIVE_IN_ADMIN).subscribe((iCan: boolean) => {
      this.iCanViewArchive = iCan;
    });

    this.admin.canI(ACLFeature.ARCHIVE).subscribe((iCan: boolean) => {
      this.iCanArchive = iCan;
    });
  }

  public selectedDriverTagFamily(tagFamily) {
    this.admin.getTagFamilyController(tagFamily.id).subscribe((res) => {
      this.activeTagFamily = { id: res.id, text: res.name };
      this.possibleTags = res.tags;
    });
  }

  public selectedDriverFamilyId(value)    { this.setDriverFamilyName(value, 'family') };
  public selectedDriverFamilyNaId(value)  { this.setDriverFamilyName(value, 'familyNa') };
  public selectedDriverFamilySaId(value)  { this.setDriverFamilyName(value, 'familySa') };
  public selectedDriverFamilyCnId(value)  { this.setDriverFamilyName(value, 'familyCn') };
  public selectedDriverFamilyRoaId(value) { this.setDriverFamilyName(value, 'familyRoa') };

  public setDriverFamilyName(value, modelName) {
    let driverFamilyIndex = this.possibleDriverFamilies.findIndex(family => family.id === value.id);
    this[modelName] = this.possibleDriverFamilies[driverFamilyIndex];
  }

  public preselectedDropdownTagFamilyValue() {
    if (!this.tagFamilies.length) {
      return [];
    } else if (null != this.activeTagFamily) {
      return [this.activeTagFamily];
    } else {
      return [this.tagFamilies[0]];
    }
  }

  public preselectedDropdownValue(modelName) {
    if (!this[modelName]) {
      return [{
        text: 'None',
        id: 'None'
      }];
    }
    if (this[modelName].treeName) {
      return [{
        text: this[modelName].treeName,
        id: this[modelName].id
      }];
    }
    return [{
      text: this[modelName].name,
      id: this[modelName].id
    }];
  }

  private mmToInch($event) {
    this.heightInch = (this.height * 0.0393700787).toFixed(3);
    this.lengthInch = (this.length * 0.0393700787).toFixed(3);
    this.widthInch = (this.width * 0.0393700787).toFixed(3);
  }

  private inchToMm($event) {
    this.height = (this.heightInch * 25.4).toFixed(1);
    this.length = (this.lengthInch * 25.4).toFixed(1);
    this.width = (this.widthInch * 25.4).toFixed(1);
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this[input.model] = input.updatedData;
  }

  public onSubmit() {
    this.loader = true;

    for (let family of this.families) {
      if (this.toggleViewStatus) {
        family.viewStatus = this.viewStatus;
      }
      if (this.toggleViewStatusNa) {
        family.viewStatusNa = this.viewStatusNa;
      }
      if (this.toggleViewStatusSa) {
        family.viewStatusSa = this.viewStatusSa;
      }
      if (this.toggleViewStatusCn) {
        family.viewStatusCn = this.viewStatusCn;
      }
      if (this.toggleViewStatusRoa) {
        family.viewStatusRoa = this.viewStatusRoa;
      }
      if (this.toggleSortOrder) {
        family.sortOrder = this.sortOrder;
      }
      if (this.toggleImages) {
        family.image = this.image;
      }
      if (this.toggleSolutionComment) {
        family.solutionComment = this.solutionComment;
      }
      if (this.toggleDriverFamily) {
        family.family = this.family;
      }
      if (this.toggleDriverFamilyNa) {
        family.familyNa = this.familyNa;
      }
      if (this.toggleDriverFamilySa) {
        family.familySa = this.familySa;
      }
      if (this.toggleDriverFamilyCn) {
        family.familyCn = this.familyCn;
      }
      if (this.toggleDriverFamilyRoa) {
        family.familyRoa = this.familyRoa;
      }
      if (this.toggleConfigurability) {
        family.isRset1 = this.isRset1;
        family.isRset2 = this.isRset2;
        family.isRset3 = this.isRset3;
        family.isRset4s = this.isRset4s;
        family.isRset5s = this.isRset5s;
        family.isRsetProgrammable = this.isRsetProgrammable;
        family.isRsetSimpleset = this.isRsetSimpleset;
        family.isRsetWireless = this.isRsetWireless;
        family.isRsetDipswitch = this.isRsetDipswitch;
      }
      if (this.toggleDataSheet) {
        family.datasheetUrl = this.datasheetUrl;
      }
      if (this.toggleDataSheetNa) {
        family.datasheetUrlNa = this.datasheetUrlNa;
      }
      if (this.toggleDataSheetCn) {
        family.datasheetUrlCn = this.datasheetUrlCn;
      }
      if (this.toggleDataSheetRoa) {
        family.datasheetUrlRoa = this.datasheetUrlRoa;
      }
      if (this.toggleDataSheetSa) {
        family.datasheetUrlSa = this.datasheetUrlSa;
      }
      if (this.togglePhaseInOut) {
        family.phaseIn = this.phaseIn;
        family.phaseOut = this.phaseOut;
      }
      if (this.togglePhaseInOutNa) {
        family.phaseInNa = this.phaseInNa;
        family.phaseOutNa = this.phaseOutNa;
      }
      if (this.togglePhaseInOutSa) {
        family.phaseInSa = this.phaseInSa;
        family.phaseOutSa = this.phaseOutSa;
      }
      if (this.togglePhaseInOutCn) {
        family.phaseInCn = this.phaseInCn;
        family.phaseOutCn = this.phaseOutCn;
      }
      if (this.togglePhaseInOutRoa) {
        family.phaseInRoa = this.phaseInRoa;
        family.phaseOutRoa = this.phaseOutRoa;
      }
      if (this.toggleHousing) {
        family.housing.height = this.height;
        family.housing.width = this.width;
        family.housing.length = this.length;
        family.housing.heightInch = this.heightInch;
        family.housing.widthInch = this.widthInch;
        family.housing.lengthInch = this.lengthInch;
      }
      if (this.toggleDimmingTypes) {
        family.dimmingTypes = this.dimmingTypes;
      }
      if (this.toggleMountingTypes) {
        family.mountingTypes = this.mountingTypes;
      }
      if (this.toggleCertifications) {
        family.certifications = this.certifications;
      }
      if (this.toggleFeatures) {
        family.features = this.features;
      }
      if (this.toggleInputVoltages) {
        family.inputVoltages = this.inputVoltages;
      }
      if (this.toggleIsolationClass) {
        family.isolationClass = this.isolationClass;
      }
      if (this.toggleDcDim) {
        family.dcDim = this.dcDim;
      }
      if (this.toggleClassification) {
        family.classification = this.classification;
      }
      if (this.toggleVoltageType) {
        family.voltageType = this.voltageType;
      }
      if (this.toggleCapabilitie) {
        family.capabilities = this.capabilities;
      }
      if (this.toggleUrls) {
        family.csaUrl = this.csaUrl;
      }
      if (this.toggleUrls) {
        family.file3dUrl = this.file3dUrl;
      }
      if (this.toggleUrls) {
        family.ulUrl = this.ulUrl;
      }
      if (this.toggleUrls) {
        family.inertekUrl = this.inertekUrl;
      }
      if (this.toggleSensorApplications) {
        family.sensorApplications = this.sensorApplications;
      }
      if (this.toggleSensorFeatures) {
        family.sensorFeatures = this.sensorFeatures;
      }
      if (this.toggleTags) {
        family.tags = this.tags;
      }
      if (this.toggleBoxQuantity) {
        family.boxQuantity = this.boxQuantity;
      }
    }

    log.d('updated families', this.families);

    this.admin.postDriverControllers(this.families).subscribe(data => {
      this.loader = false;
      this.toast.success(`Changes have been saved.`);

      const firsthalf = window.location.href.split('parentId=');
      const secondhalf = firsthalf[1].split('/');
      const thirdhalf = secondhalf[0].split(';');
      const parentId = thirdhalf[0];

      const fourthhalf = thirdhalf[1].split('=');
      const archive = fourthhalf[1];

      this.router.navigate(['/drilldown/drivers', {parentId: parentId, showArchived: archive, refresh: Date.now()}]);
    });
  }

  public onCancel() {
    log.d('onCancel');
    const firsthalf = window.location.href.split('parentId=');
    const secondhalf = firsthalf[1].split('/');
    const thirdhalf = secondhalf[0].split(';');
    const parentId = thirdhalf[0];

    const fourthhalf = thirdhalf[1].split('=');
    const archive = fourthhalf[1];

    this.router.navigate(['/drilldown/drivers', {parentId: parentId, showArchived: archive, refresh: Date.now()}]);
  }
}



// WEBPACK FOOTER //
// ./src/app/batch/drivers/edit.component.ts